<template>
	<AnalysisChart
		endpoint="web/get-cumulative-feed-analysis"
		data-key="total_feed"
		standard-key="standard_feed"
		series-label="Cumulative Feed"
		standard-label="Standard Cumulative Feed"
		yaxis-title="Feed"
	/>
</template>

<script>
import AnalysisChart from "../components/AnalysisChart.vue";

export default {
	components: { AnalysisChart },
};
</script>
